/**
 * [READ ONLY STORE]
 *
 * Featured Testimonials List
 */

import featuredTestimonials from "~/data/featured-testimonials.yaml";

export const state = () => {
    return featuredTestimonials.items.map((item, index) => {
        return { index, ...item };
    });
};
